import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';

import { SonntagIcon } from "../SonntagIcon";
import { Note } from "../Note";
import withRipple from "../hocs/withRipple";
import swapIconPath from "./swapIconPath";

import {
Box,
Details,
Title,
ImagePlaceholder,
ImageContainer,
TitleWrapper,
DotColor,
RippleContainer,
SwapIconWrap } from "./styled";



const RippleEffect = withRipple(RippleContainer);
















export const Subscription = ({
  onClick = () => void 0,
  noteData,
  title,
  img = null,
  subdued = false,
  className = '',
  dotColor,
  highlight = false,
  isBeingSwapped = false }) =>
{
  const image = img || /*#__PURE__*/React.createElement(ImagePlaceholder, { subdued: subdued });
  const theme = useContext(ThemeContext);

  return /*#__PURE__*/(
    React.createElement(Box, {
      testId: "subscription-card",
      highlight: highlight,
      className: className,
      onClick: onClick,
      defaultHoverBehavior: true }, /*#__PURE__*/

    React.createElement(Details, null, /*#__PURE__*/
    React.createElement(TitleWrapper, null, /*#__PURE__*/
    React.createElement(Title, { subdued: subdued }, title),

    dotColor && !subdued && /*#__PURE__*/React.createElement(DotColor, { dotColor: dotColor })),

    noteData && noteData.data && /*#__PURE__*/React.createElement(Note, { type: noteData.type, data: noteData.data })),


    isBeingSwapped && /*#__PURE__*/
    React.createElement(SwapIconWrap, null, /*#__PURE__*/
    React.createElement(SonntagIcon, { iconPath: swapIconPath, size: 16, color: theme.colors.secondary })), /*#__PURE__*/



    React.createElement(ImageContainer, { subdued: subdued }, image), /*#__PURE__*/

    React.createElement(RippleEffect, null)));


};